import { isUndefined, isObject } from 'lodash';
import { mainStore } from 'operass-spa/src/store';

export default (http, store, router) => {
  // let loadingInstance;
  http.interceptors.request.use((request) => {
    // if (store.state.serviceLoading) {
    //   loadingInstance = Loading.service({ fullscreen: true });
    // }
    mainStore().startLoading();

    return request;
  }, (error) => {
    // if (!isUndefined(loadingInstance)) loadingInstance.close();
    mainStore().finishLoading();

    return Promise.reject(error);
  });

  // https://github.com/mzabriskie/axios#interceptors
  http.interceptors.response.use(
    (response) => {
      if (isObject(response.data.messages)) {
        mainStore().setMessage(response.data.messages.alerts);
      }

      mainStore().finishLoading();
      // if (!isUndefined(loadingInstance)) loadingInstance.close();

      return response;
    },
    /**
    * This is a central point to handle all
    * error messages generated by HTTP
    * requests
    */
    (error) => {
      const { response } = error;
      const { message } = error;
      if (!isUndefined(response)) {
        if ([401].indexOf(response.status) > -1) {
          router.push({ name: 'auth' });
        }

        if (isObject(response.data.messages)) {
          if (isObject(response.data.messages.alerts)) {
            mainStore().setMessage(response.data.messages.alerts);
          } else {
            const alertas = [];

            response.data.messages.forEach((item) => {
              alertas.push({ type: 'ERROR', value: item });
            });

            mainStore().setMessage(alertas);
          }
        }
      } else if (!isUndefined(message)) {
        switch (message) {
          case 'Network Error': mainStore().setMessage([{ type: 'ERROR', value: 'Falha na conexão com o servidor. Aguarde um instante e tente novamente.' }]);

            break;
          default:
        }
      }

      // if (!isUndefined(loadingInstance)) loadingInstance.close();
      mainStore().finishLoading();

      return Promise.reject(error);
    },
  );
};
